export default {
	dashboard: 'Dashboard',
	tasks: 'Úkoly a informace',
	requestForSeller: 'Požadavek na obchodníka',
	contactClient: 'Kontaktuj klienta',
	campaigns: 'Kampaně',
	campaignSettings: 'Nastavení kampaní',
	campaignManagement: 'Řízení kampaní',
	contacts: 'Moje kontakty',
	reportedDocuments: 'Vykázané dokumenty',
	contractOverview: 'Přehled PS',
	subordinateUsers: 'Podřízení uživatelé',
	roboAdvisory: 'Analýzy REDy',
	contactHistory: 'Kontaktní historie',
	unlockedClients: 'Odemčení klienti',
	marketPlace: 'Příležitosti',
	manualLead: 'Manuální příležitost',
	mobileScanning: 'Úkol skenování',
	backoffice: 'Úkol backoffice',
	semaphore: 'Semafor',
	settings: 'Nastavení',
	kopr: 'Kontrola produkce',
	pkCp: 'JOK PK',
	aplications: 'Aplikace',
	pkGli: 'JOK',
	ispCp: 'ISP',
	czp: 'CZP',
	hugo: 'HUGO',
	debts: 'Pohledávky',
	lisa: 'LISA',
	lisa2: 'LISA2',
	sanMarco: 'San Marco',
};
